import AgyleDialog from '../modal/agyleDialog';

const IceDemoMock = ({open, onClose}) => {
    return (
        <AgyleDialog
            onClose={onClose}
            open={open}
            disableSave
            disableTitle
            noPadding
            width="true"
        >
            <>
                <img
                    src="/image/mock/ice/ice.png"
                    alt="ICE"
                    width={window.innerWidth - 66}
                />
            </>
        </AgyleDialog>
    );
};

export default IceDemoMock;